import React from 'react'
import { Button, LoadingSpinner } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { useLazyGetActivitiesQuery } from '../../../services/activitiesApi'
import * as styles from './seeMoreButton.css'
import { ActivityInformation, Edge } from '../../../../../typings'
import { useAppDispatch } from '../../../store/hooks'
import { setHandledError } from '../../../store/slices/handledErrorSlice'
import {
  getGroupDetailPageVariant,
  tracking,
} from '../../../lib/analytics/fpti'
import Events from '../../../lib/analytics/eventTags.js'
import serverData from '../../../utils/server-data'

const getStartCursor = (activities: Edge<ActivityInformation>[]) => {
  const lastItem = activities[activities.length - 1]
  return lastItem?.cursor ?? 1
}

export const SeeMoreButton = ({
  groupId,
  activities,
  isPayPalUser,
  isAdmin,
}: {
  groupId: string
  activities: Edge<ActivityInformation>[]
  isPayPalUser?: boolean
  isAdmin?: boolean
}) => {
  const dispatch = useAppDispatch()
  const [trigger, result] = useLazyGetActivitiesQuery()

  const handleClickOnShowMore = async () => {
    const startCursor = getStartCursor(activities)
    tracking(
      Events.p2p_pools_detail_activity_see_all_pressed({
        source: serverData.trackingParameters.externalSource,
        page_variant: getGroupDetailPageVariant(isAdmin, isPayPalUser),
        pool_id: groupId,
      }),
    )
    try {
      await trigger({ groupId, startCursor }, true).unwrap()
    } catch (error) {
      dispatch(setHandledError(error)(dispatch))
    }
  }

  return (
    <div className={styles.seeMoreContainer}>
      {result.isFetching ? (
        <LoadingSpinner data-testid="seeMoreLoader" size="lg" />
      ) : (
        <Button
          data-testid="seeMoreButton"
          variant="tertiary"
          onClick={handleClickOnShowMore}
        >
          <Message id="activity.seeMore" />
        </Button>
      )}
    </div>
  )
}
